import { IUpdateUserPermissionsRequest } from 'shared';

import { CacheTags } from '../../types/cacheTags';
import { emptySplitApi } from '../baseApi';

export const permissionsApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    updatePermissions: builder.mutation<void, { organisationId: string; update: IUpdateUserPermissionsRequest }>({
      query: ({ organisationId, update }) => ({
        url: `permissions/update`,
        method: `PATCH`,
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
        data: update,
      }),
      invalidatesTags: [{ type: CacheTags.Organisations }],
    }),
  }),
});

export const {
  useUpdatePermissionsMutation,
} = permissionsApi;
